var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "filter" }, [
    _c(
      "div",
      { staticClass: "filter-content" },
      [
        _c(
          "div",
          { staticClass: "filter__title" },
          [
            _c("TitleBlock", {
              attrs: { text: _vm.title, size: "small", color: "corporateblue" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-collapse",
          [
            _c("el-tree", {
              ref: "filter",
              attrs: {
                data: _vm.visibleFilterData,
                "show-checkbox": "",
                "node-key": "id",
                "default-expanded-keys": _vm.combinedInitialSelection,
                "default-checked-keys": _vm.combinedInitialSelection,
                props: _vm.defaultProps,
                "auto-expand-parent": "",
              },
              on: { check: _vm.handleChange },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _vm.checkFilterData()
      ? _c("div", { staticClass: "filter-bottom" }, [
          _c("div", { staticClass: "filter__save" }, [
            _vm.title.toLowerCase() !== "trackers filters"
              ? _c(
                  "button",
                  { staticClass: "filter-save", on: { click: _vm.saveFilter } },
                  [_vm._v("\n        Save to Watchlist\n      ")]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm.reset
            ? _c("div", { staticClass: "filter__reset" }, [
                _c(
                  "button",
                  {
                    staticClass: "filter-reset",
                    on: { click: _vm.resetFilter },
                  },
                  [_vm._v("Reset filters")]
                ),
              ])
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }